import { MENU, IMAGES } from '../data/content';
import { PageHero } from '../components/PageHero';
import { TileStrip } from '../components/TileStrip';
import { Reveal } from '../components/Reveal';
import { SerapeUnderline } from '../components/Serape';

const MenuPage = () => {
  return (
    <div data-testid="menu-page" className="bg-brand-night">
      <PageHero
        testid="menu-hero"
        overline="Cocina y Bar"
        title="El Menú"
        subtitle="Cocina callejera de México, cantaritos en jarrito de barro y una gran selección de agaves. Una muestra de favoritos de ejemplo — fáciles de cambiar por tu menú real."
        image={IMAGES.tacos1}
      />

      <TileStrip />

      <div className="mx-auto max-w-6xl px-6 md:px-12 py-20 md:py-28 space-y-24">
        {MENU.map((section, si) => (
          <section key={section.category} data-testid={`menu-section-${si}`}>
            <Reveal>
              <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 border-b border-brand-line pb-6 mb-10">
                <div>
                  <h2 className="font-display font-bold text-3xl sm:text-5xl tracking-tight text-brand-cream">{section.category}</h2>
                  <SerapeUnderline className="mt-4" />
                  <p className="mt-4 text-brand-cream/60 max-w-xl">{section.blurb}</p>
                </div>
                <span className="font-display font-black text-6xl text-brand-terracotta/20 leading-none hidden md:block">0{si + 1}</span>
              </div>
            </Reveal>

            <div className="grid sm:grid-cols-2 gap-x-12 gap-y-8">
              {section.items.map((item, ii) => (
                <Reveal key={item.name} delay={ii * 0.05}>
                  <div data-testid={`menu-item-${si}-${ii}`} className="flex gap-4 items-start">
                    <div className="flex-1">
                      <div className="flex items-baseline gap-3">
                        <h3 className="font-display font-semibold text-lg text-brand-cream">{item.name}</h3>
                        <span className="flex-1 border-b border-dotted border-brand-line translate-y-[-3px]" />
                        <span data-testid={`menu-price-${si}-${ii}`} className="font-display font-bold text-brand-night bg-brand-gold px-3 py-1 rounded-full text-sm shrink-0 shadow-sm shadow-black/30">
                          ${item.price}
                        </span>
                      </div>
                      <p className="mt-2 text-sm text-brand-cream/55 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </section>
        ))}

        <p className="text-center text-sm text-brand-muted italic">
          Los platillos y precios son de ejemplo. Comparte tu menú real y lo agregamos de inmediato.
        </p>
      </div>
    </div>
  );
};

export default MenuPage;
